
import { defineComponent, computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { ClientService } from '../client.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage } from 'element-plus'
export default defineComponent({
  name: 'ClientDeleteModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: null
    }
  },
  emits: ['closeClientModal', 'success'],
  setup (props, context) {
    const { t } = useI18n()
    const injector = useReflectiveInjector([ClientService])
    const clientService = injector.get(ClientService)
    const blackListFlag = ref<boolean>(false)
    const modalVisiable = computed(() => props.show)
    return {
      blackListFlag,
      modalVisiable,
      deleteTerminal () {
        clientService.deleteTerminal({ device_id: props.row.device_id, is_black: blackListFlag.value }).then(() => {
          context.emit('success')
          ElMessage.success(t('common.success'))
        }).catch(() => {
          ElMessage.error(t('common.failed'))
        })
        context.emit('closeClientModal', 'MODAL_CLIENT_DELETE')
      },
      closeModal () {
        context.emit('closeClientModal', 'MODAL_CLIENT_DELETE')
      }
    }
  }
})
